import axios from "axios";
import { API_BASE } from "../config/constants";

export const submissionResource = axios.create({
  baseURL: `${API_BASE}/api/v1/submission`,
  headers: {
    Authorization: "ApiKey 4c121cf9-4a79-4749-bcc2-c2bf5efe9d12",
  },
});

export const submissionCategoryResource = axios.create({
  baseURL: `${API_BASE}/api/v1/submission-category`,
  headers: {
    Authorization: "ApiKey 4c121cf9-4a79-4749-bcc2-c2bf5efe9d12",
  },
});

export const formSubmissionResource = axios.create({
  baseURL: `${API_BASE}/api/v1/submission`,
  headers: {
    Authorization: "ApiKey 4c121cf9-4a79-4749-bcc2-c2bf5efe9d12",
  },
});

export const submissionMailResource = axios.create({
  baseURL: `${API_BASE}/api/v1/submission/mail`,
});

export const attachmentResource = axios.create({
  baseURL: `${API_BASE}/api/v1/attachments`,
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: "ApiKey 1d952c05-474f-4006-978b-c4d871d9ae4f",
  },
});

export const verificationResource = axios.create({
  baseURL: `${API_BASE}/api/v1/mcaptcha`,
  headers: {
    Authorization: "ApiKey 4c121cf9-4a79-4749-bcc2-c2bf5efe9d12",
  },
});

export const mcaptchaSettingsResource = axios.create({
  baseURL: `${API_BASE}/api/v1/mcaptcha/settings`,
});

export const pageTypeResource = axios.create({
  baseURL: `${API_BASE}/api/v1/pageType`,
});

export const pageSettingsResource = axios.create({
  baseURL: `${API_BASE}/api/v1/settings`,
});
